import { PrimaryInput } from "common";

import * as S from "../styled";

export const EvidenceSidebarRanges = ({ranges, filters, subjectProperty, handleFirstFilterChange, handleSecondFilterChange}) => {
     return (
            <S.InputsContainer>
                {(Array.isArray(ranges) ? ranges : []).map((item) => {
                    const filterValue = filters[item.description] || {};

                    return (
                        <S.InputsBlock key={item.name}>
                            <S.Div>
                                <S.Title>{item.name} &nbsp;</S.Title>
                                <S.Description>
                                    {subjectProperty?.[item.description] ? `(${subjectProperty[item.description]})` : ""}
                                </S.Description>
                            </S.Div>
                            <S.FilterInput>
                                <PrimaryInput
                                    type="number"
                                    value={filterValue.start || ""}
                                    onChange={(e) => handleFirstFilterChange(e, item.description)}
                                    onWheel={(e) => e.target.blur()}
                                />
                                <S.Span>to</S.Span>
                                <PrimaryInput
                                    type="number"
                                    value={filterValue.end || ""}
                                    onChange={(e) => handleSecondFilterChange(e, item.description)}
                                    onWheel={(e) => e.target.blur()}
                                />
                            </S.FilterInput>
                        </S.InputsBlock>
                    );
                })}
            </S.InputsContainer>
    );
};